export default "__VITE_ASSET__de66132c__"